module.exports = __webpack_public_path__ + "static/media/web_help_5.20509fcb.jpg";